import { Directive, inject, input, TemplateRef } from '@angular/core'

@Directive({
  selector: '[slideItem]',
  exportAs: 'slideItem'
})
export class SlideItemDirective {
  hash = input<string>('')
  templateRef = inject(TemplateRef<unknown>)
}
